import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../Hotels"
import { HotelAccountings } from "../../../../Hotels/Item"
import { useOutletContext } from "react-router"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function HotelAccountingsPage() {
	const { hotel } = useOutletContext<{ hotel: IHotel }>()
	return (
		<>
			<Helmet>
				<title>Accounting | Hotel</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_ACCOUNTING}>
				<HotelAccountings hotel={hotel} />
			</ForbidUnlessAuthorized>
		</>
	)
}
